export const CONTACT_SOCIAL_LINKS = [
  {
    id: "youtube",
    label: "YouTube",
    href: "https://youtu.be/kW40Pwgp9ho",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/mathdingo/",
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/mathdingoau/",
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61561093276624",
  },
];
